import BaseFeature from '@appblocks/codegeneration/BaseFeature';
import {
    SettingType, CodeBlock, BlockType, ValidationMessage,
    ValidationMessageType, SettingState, TibboDataType,
} from '@appblocks/codegeneration/types';

export default class AzureTelemetry extends BaseFeature {
    constructor() {
        super();
        this.name = 'AzureTelemetry';
        this.id = 'azure_telemetry';
        this.singleInstance = false;
        this.devices = ['WM2000', 'WM2000EV', 'WS1102'];
        this.settings = this.settings.concat([
            {
                id: 'NAME',
                name: 'Name',
                settingType: SettingType.STRING,
                required: true,
                default: 'Telemetry_Name',
            },
            {
                id: 'TELEMETRY_ID',
                name: 'ID',
                settingType: SettingType.STRING,
                required: true,
                default: 'Telemetry_ID',
            },
        ]);
    }

    getDependencies() {
        const dependencies = [
            'azure',
        ];
        return dependencies;
    }

    getCodeBlocks() {
        const blocks: Array<CodeBlock> = [];
        const name = this.getSettingValue('NAME');
        return blocks;
    }
}
